import { AvField, AvRadio, AvRadioGroup } from "availity-reactstrap-validation"
import classnames from "classnames"
import PropTypes from "prop-types"
import {
  useCallback, useEffect, useReducer, useRef, useState
} from "react"
import Select from "react-select"

import _, { debounce } from "lodash"

// import AsyncSelect from "react-select/async"

import {
  getAllCompanies, getAllDeliveries, getAllDepartments, getAllIndividuals, getAllParameters, getAllParties, getAllPatients, getAllRoles, getAllTestProfiles,
  getAllTests, getAllUsers, getCodesByParameterId, getRequestSamples
} from "helpers/app-backend"

import { getAllReport } from "helpers/app-backend/reports_backend_helper"
import { useDetectedChanges } from "helpers/hooks"
import { getI18nextLng, isEmptyArray } from "helpers/utilities"

import { InlineEditType, parameterCode, PROFILE_TYPE, TestProfileStatus, TestProfileTypeText } from "constant/utility"
import { getAllMachine } from "helpers/app-backend/machines_backend_helper"
import { getPrinters } from "helpers/fakebackend_helper"
import { isEmpty } from "lodash"
import { useSelector } from "react-redux"
import { Label } from "reactstrap"
import { RollbackButton } from "."
import { getAllHisConnector } from "helpers/app-backend/hisConnectors_backend_helper"
import React from "react"
import { CustomButton, CustomButtonGroup } from "../Button"

let valueMultiSelect = [];
const CustomSelectButton = ({
  value,
  name,
  required,
  errorMessage,
  code,
  group,
  onChange,
  isDependent,
  isMulti,
  portal,
  label,
  detected,
  options,
  readOnly,
  valueName,
  showDefaultAll,
  customSearchQuery,
  placeholder,
  maxItems = 3,
  type = "radio"
}) => {
  const [defaultValue, setDefaultValue] = useState()
  const [inputValue, setInputValue] = useState()
  const inputId = new Date().getTime()

  const [state, setState] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    { loading: false, items: [] }
  )

  const { testProfileTests } = useSelector(state => ({
    testProfileTests: state.testProfile.testProfileTests,
  }))

  const inputRef = useRef()
  const [valueInput, isChanged] = useDetectedChanges(
    value,
    isMulti ? defaultValue : defaultValue?.[0]
  )

  const onUndoHandler = () => {
    onInputChangeHandler(inputValue)
    onChangeHandler(
      isMulti ? (isEmpty(valueInput) ? [] : valueInput) : { value: valueInput }
    )
  }

  const isTouched = inputRef.current?.FormCtrl.isTouched()
  const isDirty = inputRef.current?.FormCtrl.isDirty()
  const isInvalid =
    !readOnly &&
    required &&
    isEmptyArray(defaultValue) &&
    (isTouched || isDirty)

  let lang = getI18nextLng()

  // COMMON CODES
  const fetchCodes = async (code, group) => {
    const query = { lang, group, sort:'Sequence:asc' }
    const res = await getCodesByParameterId(code, query)
    res?.map(_item => {
      _item.value = _item.code
      _item.label = _item.message
      return _item
    })

    return res
  }

  const fetchCodesByParameterId = async (id, text) => {
    const query = { lang: "*", search: text }
    const res = await getCodesByParameterId(id, query)
    res?.map(_item => {
      _item.value = _item.code
      _item.label = `${_item.message} (${_item.code})`
      return _item
    })
    return res
  }

  const fetchCodesByParameterIdWithLanguage = async (id, text) => {
    const query = { lang: 'vi', search: text }
    const res = await getCodesByParameterId(id, query)
    res?.map(_item => {
      _item.value = _item.code
      _item.label = `${_item.message} (${_item.code})`
      return _item
    })
    return res
  }

  const fetchTestProfileMapping = async keySearch => {
    if (keySearch === valueName)
      keySearch = ''

    const query = {
      status: TestProfileStatus.ACTIVE,
      search: keySearch,
      size: 15
    }

    const res = await getAllTestProfiles(query)
    const result = []
    if (res.data) {
      res.data.map(_prof =>
        result.push(
          {
            label: `${_prof.profileName} (${_prof.code})`,
            value: _prof.code
          })
      )
    }

    if (!valueName && valueName !== "" && result.findIndex(x => x.value === value) < 0) {
      result.unshift({
        value: value,
        label: valueName
      })
    }

    return result
  }

  const fetchTests = async keySearch => {
    if (keySearch === valueName)
      keySearch = ''
    const query = {
      size: 15,
      search: keySearch,
      inUse: true,
    }
    const res = await getAllTests(query)

    let data = []
    if (res.data)
      data = res.data.map(_item => {
        _item.value = _item.testCode
        _item.label = `${_item.testName} (${_item.testCode})`
        return _item
      })
    if (valueName && valueName !== "" && data.findIndex(x => x.value === value) < 0) {
      data.unshift({
        value: value,
        label: valueName
      })
    }
    return data
  }

  // COMPANIES
  const fetchCompanies = async (value, group) => {
    let query = { size: 5, search: value }
    const res = await getAllCompanies(query)
    let data = []
    if (res.data)
      data = res.data.map(_item => {
        _item.value = _item.id
        _item.label = _item.name
        return _item
      })

    return data
  }

  // DEPARTMENTS
  const fetchDepartments = async (value, group) => {
    let query = { size: 5, search: value }
    if (group && group != 'null' && group != 'undefined') {
      query.companyId = group
    }
    const res = await getAllDepartments(query)
    let data = []
    if (res.data)
      data = res.data.map(_item => {
        _item.value = _item.id
        _item.label =
          lang === "vi" ? _item.name : _item.englishName || _item.name
        return _item
      })

    return data
  }

  // ROLES
  const fetchRoles = async () => {
    const query = { size: 100 }
    const res = await getAllRoles(query)
    let data = []
    if (res.data)
      data = res.data.map(_item => {
        _item.value = _item.id
        _item.label = _item.roleName
        return _item
      })

    return data
  }

  // USERS
  const fetchUsers = async keySearch => {
    const query = { size: 5, search: keySearch }
    const res = await getAllUsers(query)
    let data = []
    if (res.data)
      data = res.data.map(_item => {
        _item.value = _item.id
        _item.label = _item.familyName + " " + _item.givenName
        return _item
      })
    if (valueName && valueName !== "" && data.findIndex(x => x.value === value) < 0) {
      data.unshift({
        value: value,
        label: valueName
      })
    }
    const result = [...new Map(data.map(x => [`${x['value']}`, x])).values()];
    return result;
  }

  // PROFILES
  const fetchParties = async (profileId, value) => {
    const query = { size: 5, profileId, search: value }
    const res = await getAllParties(query)
    let data = []
    if (res.data)
      data = res.data.map(_item => {
        _item.value = _item.id
        _item.label = _item.name
        return _item
      })

    return data
  }

  // TESTPROFILES
  const fetchTestProfiles = async keySearch => {
    if (keySearch === valueName)
      keySearch = ''
    const query = {
      size: 100,
      search: keySearch,
      type: TestProfileTypeText.PROFILE,
      status: TestProfileStatus.ACTIVE,
    }
    const res = await getAllTestProfiles(query)
    let data = []
    if (res.data)
      data = res.data.map(_item => {
        _item.value = _item.id
        _item.label = _item.profileName
        return _item
      })
    if (valueName && valueName !== "" && data.findIndex(x => x.value === value) < 0) {
      data.unshift({
        value: value,
        label: valueName
      })
    }
    return data
  }

  //tests
  const fetchAllTests = async (keySearch, group) => {
    if (keySearch === valueName)
      keySearch = ''
    if (keySearch && keySearch.indexOf(' - ') >= 0) {
      const tmp = keySearch.split('- ')
      if (tmp)
        keySearch = tmp[1]
    }
    const query = {
      size: 999,
      search: keySearch,
      inUse: true,
      sampleType: group
    }
    const res = await getAllTests(query)
    let data = []
    if (res.data)
      data = res.data.map(_item => {
        _item.value = _item.id
        _item.label = `${_item.testCode} - ${_item.testName}`
        return _item
      })
    if (valueName && valueName !== "" && data.findIndex(x => x.value === value) < 0) {
      data.unshift({
        value: value,
        label: valueName
      })
    }
    if (showDefaultAll) {
      data.unshift({
        value: 0,
        label: 'All'
      })
    }
    return data
  }

  const fetchAllTestInModalProfile = async (keySearch, group) => {
    if (keySearch === valueName)
      keySearch = ''
    const query = {
      size: 999,
      search: keySearch,
      inUse: true,
      sampleType: group
    }
    const res = await getAllTests(query)
    let data = []
    if (res.data) {
      data = res.data.filter(x => testProfileTests.findIndex(z => z.testId == x.id) < 0).map(_item => {
        _item.value = _item.id
        _item.label = `${_item.testCode} - ${_item.testName}`
        return _item
      })
    }
    if (valueName && valueName !== "" && data.findIndex(x => x.value === value) < 0) {
      data.unshift({
        value: value,
        label: valueName
      })
    }
    if (showDefaultAll) {
      data.unshift({
        value: 0,
        label: 'All'
      })
    }
    return data
  }

  // PHYSICIANS
  const fetchPhysicians = async (keySearch) => {
    // if (keySearch === valueName)
    //   keySearch = ''
    const query = {
      size: 5,
      search: keySearch || '',
      profileId: PROFILE_TYPE.Physician,
    }
    const res = await getAllPatients(query)
    let data = []
    if (res.data) {
      //department
      let arrDepartment = [];
      res.data.map(x => {
        if (x.furtherValue && x.furtherValue != "") {
          const tmp = JSON.parse(x.furtherValue);
          const index = tmp.findIndex(x => x.FieldCode == "Department")
          if (index >= 0) {
            arrDepartment.push(tmp[index]['FurtherValue']);
          }
        }
      });
      let resDepartment = [];
      arrDepartment = arrDepartment.filter(x => !isEmpty(x))
      if (arrDepartment.length > 0) {
        const deptValues = await getAllDepartments({ id: arrDepartment })
        resDepartment = deptValues.data || []
      }
      //company
      const arrCompanyId = res.data.map(x => x.managementCompanyId) || [];
      const arrCompanyIdDistinct = arrCompanyId.filter((x, index) => !arrCompanyId.includes(x, index + 1)) || []
      let resCompany = [];
      if (arrCompanyIdDistinct.length > 0)
        resCompany = await getAllCompanies({ id: arrCompanyIdDistinct })
      data = res.data.map(_item => {
        let name = `${lang === "vi" ? _item.name : _item.englishName || _item.name}`;
        //department
        if (resDepartment.length > 0) {
          const further = JSON.parse(_item.furtherValue)?.find(x => x.FieldCode == 'Department')
          if (further) _item.departmentName = resDepartment?.find(x => `${x.id}` == `${further.FurtherValue}`)?.name
        }
        //company
        _item.managementCompanyId = resCompany.data?.find(x => x.id == _item.managementCompanyId)?.shortName || ''
        if (_item.dobString) {
          name = `${name}`
        }
        let arr = []
        _item.value = _item.id
        if (_item.fields && _item.fields != '[{}]' && _item.fields != '') {
          arr = SortFieldIndividuals(_item)
        }
        arr.unshift(name);
        let label = arr.filter(Boolean).join(' • ')
        _item.label = `${label}`
        return _item
      })
    }

    return data
  }

  const fetchPatientDelivery = async (keySearch) => {
    if (keySearch != null && keySearch != '')
      return fetchPatients(keySearch)
    return []
  }
  // PATIENT
  const fetchPatients = async (keySearch) => {
    // if (keySearch === valueName)
    //   keySearch = ''
    const query = {
      size: 5,
      search: keySearch || '',
      profileId: PROFILE_TYPE.PATIENT,
    }
    const res = await getAllPatients(query)
    let data = []
    if (res.data) {
      //department
      let arrDepartment = [];
      res.data.map(x => {
        if (x.furtherValue && x.furtherValue != "") {
          const tmp = JSON.parse(x.furtherValue);
          const index = tmp.findIndex(x => x.FieldCode == "Department")
          if (index >= 0) {
            arrDepartment.push(tmp[index]['FurtherValue']);
          }
        }
      });
      let resDepartment = [];
      arrDepartment = arrDepartment.filter(x => !isEmpty(x))
      if (arrDepartment.length > 0) {
        const deptValues = await getAllDepartments({ id: arrDepartment })
        resDepartment = deptValues.data || []
      }
      //company
      const arrCompanyId = res.data.map(x => x.managementCompanyId) || [];
      const arrCompanyIdDistinct = arrCompanyId.filter((x, index) => !arrCompanyId.includes(x, index + 1)) || []
      let resCompany = [];
      if (arrCompanyIdDistinct.length > 0)
        resCompany = await getAllCompanies({ id: arrCompanyIdDistinct })
      data = res.data.map(_item => {
        let name = `${lang === "vi" ? _item.name : _item.englishName || _item.name}`;
        //department
        if (resDepartment.length > 0) {
          const further = JSON.parse(_item.furtherValue)?.find(x => x.FieldCode == 'Department')
          if (further) _item.departmentName = resDepartment?.find(x => `${x.id}` == `${further.FurtherValue}`)?.name
        }
        //company
        _item.managementCompanyId = resCompany.data?.find(x => x.id == _item.managementCompanyId)?.shortName || ''
        if (_item.dobString) {
          name = `${name}`
        }
        let arr = []
        _item.value = _item.patientId
        if (_item.fields && _item.fields != '[{}]' && _item.fields != '') {
          arr = SortFieldIndividuals(_item)
        }
        arr.unshift(name);
        let label = arr.filter(Boolean).join(' • ')
        _item.label = `${label}`
        return _item
      })
    }
    return data
  }

  // INDIVIDUALS
  const fetchIndividuals = async (keySearch) => {
    if (keySearch === valueName)
      keySearch = ''
    const query = {
      size: 5,
      search: keySearch,
    }
    const res = await getAllIndividuals(query)
    let data = []
    if (res.data)
      data = res.data.map(_item => {
        _item.value = _item.patientId
        _item.label =
          lang === "vi" ? _item.name : _item.englishName || _item.name
        return _item
      })

    return data
  }

  const SortFieldIndividuals = (item) => {
    let arr = [];
    let _item = item;
    let fields = JSON.parse(_item.fields) || []
    fields.forEach(eField => {
      let fieldCode = eField.FieldCode;
      let addressFields = [];
      if (_item.addressFields && _item.addressFields != '[{}]' && _item.addressFields != '') {
        addressFields = JSON.parse(_item.addressFields)
      }
      let contactFields = [];
      if (_item.contactFields && _item.contactFields != '[{}]' && _item.contactFields != '') {
        contactFields = JSON.parse(_item.contactFields)
      }
      if (fieldCode.includes("Contact.")) {
        if (contactFields.length > 0) {
          const field = fieldCode.split('.')[1]
          if (field?.toUpperCase() == "CONTACTROLE") {
            arr.push(contactFields[0]['ContactRole'])
          }
          else {
            arr.push(contactFields[0][field])
          }
        }
      }
      else if (fieldCode.includes("Address.")) {
        if (addressFields.length > 0) {
          const field = fieldCode.split('.')[1]
          if (field?.toUpperCase() == "TYPE") {
            arr.push(addressFields[0]['TypeName'])
          }
          else if (field?.toUpperCase() == "Address") {
            arr.push(_item.fullAddress)
          }
          else {
            arr.push(addressFields[0][field])
          }
        }
      }
      else {
        if (fieldCode?.toUpperCase() === 'dob'.toUpperCase()) {
          arr.push(_item.dobName)
        }
        else {
          fieldCode = fieldCode.charAt(0).toLowerCase() + fieldCode.slice(1)
          if (_item.hasOwnProperty(fieldCode + "Name")) {
            arr.push(_item[fieldCode + "Name"])
          } else {
            arr.push(_item[fieldCode])
          }
        }
      }
    });
    return arr;
  }

  //parameters
  const fetchAllParametersConnector = async (keySearch, group) => {
    if (keySearch === valueName)
      keySearch = ''
    const query = {
      size: 15,
      search: keySearch,
      type: group
    }
    const res = await getAllParameters(query)
    let data = []
    if (res.data)
      data = res.data.map(_item => {
        _item.value = _item.parameterKey
        _item.label = `${_item.name}`
        return _item
      })
    if (data.findIndex(x => x.value === value) < 0 && value) {
      data.unshift({
        value: value,
        label: valueName
      })
    }
    return data
  }

  const fetchAllPrinters = async (keySearch, type) => {
    if (keySearch === valueName)
      keySearch = ''
    const query = {
      size: 100,
      search: keySearch,
      type: type,
    }
    const res = await getPrinters(query)
    let data = []
    if (res)
      data = res.map(_item => {
        _item.value = _item.id
        _item.label = _item.name
        return _item
      })
    if (valueName && valueName !== "" && data.findIndex(x => x.value === value) < 0) {
      data.unshift({
        value: value,
        label: valueName
      })
    }
    return data
  }

  const fetchAllReports = async (keySearch, type) => {
    if (keySearch === valueName)
      keySearch = ''
    const query = {
      size: 100,
      search: keySearch,
      type: type,
    }
    const res = await getAllReport(query)

    let data = []
    if (res.data)
      data = res.data.map(_item => {
        _item.value = _item.id
        _item.label = _item.name
        return _item
      })
    if (valueName && valueName !== "" && data.findIndex(x => x.value === value) < 0) {
      data.unshift({
        value: value,
        label: valueName
      })
    }
    return data
  }

  const fetchAllParameters = async (keySearch, group) => {
    if (keySearch === valueName)
      keySearch = ''
    const query = {
      size: 15,
      search: keySearch,
    }

    if (group !== parameterCode.ALL_GROUP) query.type = group

    const res = await getAllParameters(query)
    let data = []
    if (res.data)
      data = res.data.map(_item => {
        _item.value = _item.parameterKey
        _item.label = `${_item.name} (${_item.parameterKey})`
        return _item
      })
    if (data.findIndex(x => x.value === value) < 0 && value) {
      data.unshift({
        value: value,
        label: valueName
      })
    }
    return data
  }

  const fetchAllMappingCode = async () => {
    const query = {
      size: 100,
      search: 'mapping',
      type: 'M'
    }
    const res = await getAllParameters(query)
    let data = []
    if (res.data)
      data = res.data.map(_item => {
        _item.value = _item.parameterKey
        _item.label = `${_item.name} (${_item.parameterKey})`
        return _item
      })
    // if (data.findIndex(x => x.value === value) < 0 && value) {
    //   data.unshift({
    //     value: value,
    //     label: valueName
    //   })
    // }
    return data
  }

  const fetchMachines = async (keySearch, group) => {
    if (keySearch === valueName)
      keySearch = ''

    const query = {
      protocolId: group,
      search: keySearch,
      size: 15,
      status: 1
    }

    const res = await getAllMachine(query)
    const result = []
    if (res.data) {
      res.data.map(_prof =>
        result.push(
          {
            label: `${_prof.name}`,
            value: _prof.id
          })
      )
    }
    if (!valueName && valueName !== "" && result.findIndex(x => x.value === value) < 0) {
      result.unshift({
        value: value,
        label: valueName
      })
    }

    return result
  }

  const fetchCollector = async keySearch => {
    if (keySearch === valueName)
      keySearch = ''
    const query = {
      size: 5,
      search: keySearch,
    }
    const res = await getAllUsers(query)
    let data = []
    if (res.data)
      data = res.data.map(_item => {
        _item.value = _item.id
        _item.label = `${_item.familyName} ${_item.givenName}`
        return _item
      })
    if (valueName && valueName !== "" && data.findIndex(x => `${x.value}` === `${value}`) < 0) {
      data.unshift({
        value: value,
        label: valueName
      })
    }
    return data;
  }

  const fetchSampleForDelivery = async (searchQuery) => {
    const query = { ...customSearchQuery, ...searchQuery }
    const res = await getRequestSamples(query)
    let data = []
    if (res)
      data = res.map(_item => {
        _item.value = _item.sid
        _item.label = `${_item.sid} • ${_item.sampleType} • ${_item.patientName} `
        return _item
      })
    if (valueName && valueName.trim() !== "" && data.findIndex(x => `${x.value}` === `${value}`) < 0) {
      data.unshift({
        value: value,
        label: valueName
      })
    }
    return data
  }

  const fetchAllDeliveryModal = async (searchQuery, id) => {
    const query = { size: 20, search: searchQuery }
    const res = await getAllDeliveries(query)
    let data = []
    if (res.data)
      data = res.data.map(_item => {
        _item.value = _item.id
        _item.label = `${_item.deliveryDate}`
        return _item
      })
    data = data.filter(x => `${x.id}` != `${id}`)
    return data
  }

  // COMMON_PHYSICIANS
  const fetchCommonPhysicians = async (keySearch) => {
    if (keySearch === valueName)
      keySearch = ''
    const query = {
      size: 5,
      search: keySearch,
      profileId: PROFILE_TYPE.Physician,
    }

    const res = await getAllIndividuals(query)
    let data = []
    if (res.data)
      data = res.data.map(_item => {
        _item.value = _item.id
        _item.label =
          lang === "vi" ? _item.name : _item.englishName || _item.name
        return _item
      })

    return data
  }

  const fetchAllDelivery = async (searchQuery, id) => {
    let query = { size: 100, ...customSearchQuery, id: _.union(customSearchQuery.id, valueMultiSelect) }
    if (query.id && isNaN(query.id)) {
      delete query.id
    }
    let res = await getAllDeliveries(query)
    let data = []
    if (res.data)
      data = res.data.map(_item => {
        _item.value = _item.id
        _item.label = `${_item.deliveryDate}`
        return _item
      })
    if (!searchQuery.id) {
      query = { size: 100, search: searchQuery }
      res = await getAllDeliveries(query)
      let dataWithSearch = []
      if (res.data)
        dataWithSearch = res.data.map(_item => {
          _item.value = _item.id
          _item.label = `${_item.deliveryDate}`
          return _item
        })
      if (dataWithSearch.length > 0)
        data = data.concat(dataWithSearch.filter(x => data.findIndex(z => `${z.id}` == `${x.id}`) < 0))
    }
    let currentId = customSearchQuery.currentId ? customSearchQuery.currentId : 0;
    data = data.filter(x => `${x.id}` != `${id}` && `${x.id}` != `${currentId}`)
    return data
  }

  const fetchAllHisConnector = async (keySearch) => {
    if (keySearch === valueName)
      keySearch = ''
    const query = {
      size: 0,
      search: keySearch,
    }
    const res = await getAllHisConnector(query)
    let data = []
    if (res)
      data = res.data.map(_item => {
        _item.value = _item.id
        _item.label = _item.name
        return _item
      })
    if (valueName && valueName !== "" && data.findIndex(x => x.value === value) < 0) {
      data.unshift({
        value: value,
        label: valueName
      })
    }
    return data
  }

  const fetchTrueHisConnector = async (keySearch) => {
    if (keySearch === valueName)
      keySearch = ''
    const query = {
      size: 0,
      search: keySearch,
      status: 1,
    }
    const res = await getAllHisConnector(query)
    let data = []
    if (res)
      data = res.data.map(_item => {
        _item.value = _item.code
        _item.label = _item.name
        return _item
      })
    if (valueName && valueName !== "" && data.findIndex(x => x.value === value) < 0) {
      data.unshift({
        value: value,
        label: valueName
      })
    }
    return data
  }


  const fetchOptions = useCallback(async (code, group, value) => {
    setState({ loading: true })
    let res = []
    if (code === parameterCode.COMPANIES) {
      res = await fetchCompanies(value, group)
    } else if (code === parameterCode.DEPARTMENTS) {
      res = await fetchDepartments(value, group)
    } else if (code === parameterCode.ROLES) {
      res = await fetchRoles()
    } else if (code === parameterCode.USERS) {
      res = await fetchUsers(value)
    } else if (code === parameterCode.TESTPROFILE) {
      res = await fetchTestProfiles(value)
    } else if (code === parameterCode.TESTPROFILE_TEST) {
      res = await fetchAllTests(value, group)
    }
    else if (code === parameterCode.TESTPROFILE_TEST_NOT_IN_LIST) {
      res = await fetchAllTestInModalProfile(value, group)
    } else if (code === parameterCode.HISCONNECTOR) {
      res = await fetchAllParametersConnector(value, group)
    } else if (code === parameterCode.ALL_PARAMETER) {
      res = await fetchAllParameters(value, group)
    }
    else if (code === parameterCode.CONNECTOR_MAPPING_CODE) {
      res = await fetchAllMappingCode()
    }
    else if (code === parameterCode.PHYSICIANS) {
      res = await fetchPhysicians(value)
    } else if (code === parameterCode.INDIVIDUALS) {
      res = await fetchIndividuals(value)
    } else if (code === parameterCode.COMMON_PHYSICIANS) {
      res = await fetchCommonPhysicians(value)
    } else if (code === parameterCode.PATIENTS) {
      res = await fetchPatients(value)
    } else if (code === parameterCode.PATIENTS_DELIVERY) {
      res = await fetchPatientDelivery(value)
    } else if (group === parameterCode.HIS_MAPPING_KEY_WITH_LANG) {
      res = await fetchCodesByParameterIdWithLanguage(code, value)
    } else if (group === parameterCode.HIS_MAPPING_KEY) {
      res = await fetchCodesByParameterId(code, value)
    } else if (code === parameterCode.LIS_MAPPING_KEY) {
      res = await fetchTests(value)
    } else if (code === parameterCode.SAMPLES_FOR_DELIVERY) {
      res = await fetchSampleForDelivery(value)
    } else if (code === parameterCode.LIS_PROFILE_MAPPING_KEY) {
      res = await fetchTestProfileMapping(value)
    } else if (code === parameterCode.DELIVERY) {
      res = await fetchAllDelivery(value, group)
    } else if (code === parameterCode.DELIVERY_MODAL) {
      res = await fetchAllDeliveryModal(value, group)
    } else if (code === parameterCode.INSTRUMENT) {
      res = await fetchMachines(value, group)
    } else if (code === InlineEditType.TESTREQUEST_SAMPLE_COLLECTOR) {
      res = await fetchCollector(value, group)
    } else if (code === parameterCode.REPORT_TEMPLATE) {
      res = await fetchAllReports(value, group)
    } else if (code === parameterCode.HISCONNECTOR_LIST) {
      res = await fetchAllHisConnector(value, group)
    } else if (code === parameterCode.HISCONNECTOR_TRUE_LIST) {
      res = await fetchTrueHisConnector(value, group)
    } else if (code === parameterCode.PRINTER) {
      res = await fetchAllPrinters(value, group)
    } else if (code.indexOf("_") >= 0 || code === parameterCode.PROFILE) {
      const profileId = code.substring(code.indexOf("_") + 1)
      if (profileId > 0) res = await fetchParties(profileId, value)
      else res = await fetchParties(undefined, value)
    } else {
      res = await fetchCodes(code, group)
    }
    setState({ items: res, loading: false })
  }, [])

  const onChangeHandler = (e, b) => {
    const element = document.getElementById(name + "" + inputId)
    var event = new Event("change", { bubbles: true })

    const value =
      (isMulti
        ? (Array.isArray(e) ? e?.map(_value => {
          return _value.value
        }) : e?.split(','))
        : [e?.value]) || []
    element.value = value || ""
    element.dispatchEvent(event)
    setDefaultValue(value || "")
    valueMultiSelect = value
    onChange(name, value, state.items?.find(x => `${x.value}` == `${value}`)?.label, state.items?.filter(x => `${x.value}` == `${value}`))
  }

  const isValidStyle = isInvalid && {
    borderColor: "#f46a6a !important",
    backgroundImage: `url(
    "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='%23f46a6a'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='%23f46a6a' stroke='none'/></svg>"
  )`,
    backgroundPosition: "right 2.75rem center, center right 0.5rem",
    backgroundSize: "17px 18px, calc(0.75em + 0.47rem) calc(0.75em + 0.47rem)",
    backgroundRepeat: "no-repeat",
  }

  const colourStyles = {
    control: (styles, { data, isDisabled, isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isDisabled ? "#edf1f2 !important" : "white",
      fontSize: "13px",
      cursor: isDisabled ? "not-allowed" : "default",
      ...isValidStyle,
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        fontSize: "13px",
        cursor: isDisabled ? "not-allowed" : "default",
      }
    },
    singleValue: (provided, state) => {
      const opacity =
        state.isDisabled || !state.data.value || state.data.value === "0"
          ? 0.7
          : 1
      const transition = "opacity 300ms"

      return { ...provided, opacity, transition }
    },

    menuPortal: provided => ({
      ...provided,
      zIndex: 9999,
    }),
    menu: provided => ({ ...provided, zIndex: 9999 }),
  }

  const onInputChangeHandler = debounce(value => {
    if (value?.length > 0 && code && (!isDependent || (isDependent && group))) {
      setState({ loading: true })
      fetchOptions(code, group, value)
    }
  }, 600)

  useEffect(() => {
    if (code && isDependent && group) fetchOptions(code, group)
    else setState({ items: [] })
  }, [code, group, isDependent])

  useEffect(() => {
    onInputChangeHandler(inputValue)
  }, [inputValue, code, group, isDependent])

  useEffect(() => {
    setDefaultValue(isMulti ? value : [value])
    setInputValue(valueName)
  }, [value, valueName])

  useEffect(() => {
    if (!isEmpty(options)) {
      if (valueName && valueName !== "" && options.findIndex(x => x.value === value) < 0) {
        options.unshift({
          value: value,
          label: valueName
        })
      }
      setState({ items: options })
    }
  }, [options])
  useEffect(() => {
    if (code)
      fetchOptions(code, group, customSearchQuery)
    else setState({ items: [] })
  }, [customSearchQuery])

  const setFirstDefaultValue = () => {
    onChange(name, [state.items[0].value])
    setDefaultValue(state.items[0].value)
    let res = document.getElementById(name + "" + inputId)
    if (res)
      res.value = state.items[0].value
  }
  return (
    <>
      <div className="label-group-relative position-relative">
        {label && (
          <Label for={name}>
            {label}
            {required && <span className="text-danger">*</span>}
          </Label>
        )}

        <RollbackButton
          display={isChanged && detected}
          onClick={onUndoHandler}
        />
      </div>
      {state.items.length > maxItems || state.items.length == 0 ?
        <Select
          isClearable
          placeholder={placeholder || ''}
          isLoading={state.loading}
          // inputValue={inputValue}
          onInputChange={onInputChangeHandler}
          id={name + "" + inputId}
          menuPlacement="auto"
          maxMenuHeight={150}
          menuPortalTarget={!portal && document.body}
          styles={colourStyles}
          isDisabled={readOnly}
          isMulti={isMulti}
          value={state.items.filter(
            _item =>
              defaultValue?.findIndex(
                _defaultValue =>
                  JSON.stringify(_defaultValue + "") ===
                  JSON.stringify(_item.value + "")
              ) >= 0
          )}
          onChange={onChangeHandler}
          options={state.items}
          classNamePrefix="select2-selection"
          className={classnames(
            { "has-changed": isChanged && detected },
            "form-select2 is-touched is-dirty av-invalid is-invalid"
          )}
        />
        :
        <React.Fragment>
          {type == "radio" ?
            <AvRadioGroup
              inline
              id={name + "" + "select-custombutton"}
              className="radioCustom"
              name={name}
              value={value}
              onChange={(e) => {
                onChange(name, e.target.value)
              }}
            >
                {state.items.map((item, index) => {
                return <span style={{marginRight : '60px'}} key={index}>
                  <AvRadio
                  label={item.label}
                  value={item.value}
                  key={index}
                  style={{transform: 'scale(1.3)'}}
                />
                </span>
              }          
              )}
            </AvRadioGroup>
            :
            <CustomButtonGroup className="justify-content-start">
              {state.items.map((item, index) => (
                <CustomButton
                  text={item.label}
                  disabled={readOnly}
                  name="type"
                  type="button"
                  onClick={e => {
                    if (required != true && (item.value && (item.value == defaultValue || [item.value] == defaultValue))) {
                      onChange(name, [undefined])
                      setDefaultValue(undefined)
                      let res = document.getElementById(name + "" + inputId)
                      res.value = undefined
                    }
                    else {
                      onChange(name, [item.value], item.label)
                      setDefaultValue([item.value])
                      let res = document.getElementById(name + "" + inputId)
                      res.value = item.value
                    }
                  }}
                  color={(item.value != undefined && item.value == defaultValue) ? "primary" : "light"}
                  className="button-width"
                  value={item.value}
                  key={index}
                />
              ))}
            </CustomButtonGroup>
          }
        </React.Fragment>
      }
      {isInvalid && (
        <div className="text-danger form-group">
          <div className="is-touched is-dirty av-invalid is-invalid"></div>
          <div className="invalid-feedback">{errorMessage}</div>
        </div>
      )}
      {state.items.length > maxItems || state.items.length == 0 || (type != "radio" && state.items.length <= maxItems) &&
        <div className="d-none">
          <AvField
            multiple={isMulti}
            name={name}
            id={name + "" + inputId}
            type="select"
            className={`form-select`}
            value={isMulti ? defaultValue : defaultValue?.[0]}
            errorMessage={errorMessage}
            required={!readOnly && required}
            ref={inputRef}
            readOnly={readOnly}
          >
            <option value="">--Select--</option>
            {state.items.map((_item, idx) => (
              <option key={idx} value={_item.value}>
                {_item.label}
              </option>
            ))}
          </AvField>
        </div>
      }
    </>
  )
}

CustomSelectButton.propTypes = {
  onChange: PropTypes.func,
  name: PropTypes.string.isRequired,
  isDependent: PropTypes.bool,
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
  value: PropTypes.any,
  valueName: PropTypes.string.isRequired,
  group: PropTypes.string,
  code: PropTypes.string,
  isMulti: PropTypes.bool,
  portal: PropTypes.bool,
  label: PropTypes.any.isRequired,
  detected: PropTypes.bool,
  options: PropTypes.array,
  readOnly: PropTypes.bool,
  showDefaultAll: PropTypes.bool,
}

CustomSelectButton.defaultProps = {
  name: "",
  onChange: () => { },
  isDependent: false,
  errorMessage: "This field is invalid",
  portal: false,
}

export default CustomSelectButton